/**
 * IDEMPOTENCY-1 — cross-module idempotency-key substrate schemas.
 */
import { z } from 'zod';

export const IdempotencyNamespace = z.enum([
  'event-publish',
  'aegis-action',
  'regulatory-artifact',
  'customer-notify',
  'financial-transaction',
]);

export const IdempotencyKey = z.object({
  id: z.string(),                               // composite: <tenantId>:<namespace>:<keyValue>
  tenantId: z.string(),
  namespace: IdempotencyNamespace,
  keyValue: z.string(),
  firstSeenAt: z.string(),
  ttlExpiresAt: z.string(),                     // Firestore TTL field
  resultRef: z.string().nullable().default(null), // optional ref to original outcome
});
